import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './store/authStore';
import { initTelegramWebApp } from './utils/telegram';

// Telegram WebApp API доступен глобально
declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        ready: () => void;
        expand: () => void;
        initData: string;
        showAlert: (message: string) => void;
      };
    };
  }
}
import { AuthPage } from './pages/AuthPage';
import { HomePage } from './pages/HomePage';
import { BaseGamePage } from './pages/games/BaseGamePage';
import { PlatesGamePage } from './pages/games/PlatesGamePage';
import { RouletteGamePage } from './pages/games/RouletteGamePage';
import { RegionsGamePage } from './pages/games/RegionsGamePage';
import { GameHistoryPage } from './pages/GameHistoryPage';
import { ProfilePage } from './pages/ProfilePage';
import { Layout } from './components/Layout';
import { OfflineStatus } from './components/OfflineStatus';

function App() {
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    // Initialize Telegram WebApp
    initTelegramWebApp();
  }, []);

  return (
    <BrowserRouter>
      <OfflineStatus />
      <Layout>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/"
            element={isAuthenticated ? <HomePage /> : <Navigate to="/auth" />}
          />
          <Route
            path="/games/base/:gameId"
            element={
              isAuthenticated ? <BaseGamePage /> : <Navigate to="/auth" />
            }
          />
          <Route
            path="/games/plates/:gameId"
            element={
              isAuthenticated ? <PlatesGamePage /> : <Navigate to="/auth" />
            }
          />
          <Route
            path="/games/roulette/:gameId"
            element={
              isAuthenticated ? <RouletteGamePage /> : <Navigate to="/auth" />
            }
          />
          <Route
            path="/games/regions/:gameId"
            element={
              isAuthenticated ? <RegionsGamePage /> : <Navigate to="/auth" />
            }
          />
          <Route
            path="/history"
            element={
              isAuthenticated ? <GameHistoryPage /> : <Navigate to="/auth" />
            }
          />
          <Route
            path="/profile"
            element={
              isAuthenticated ? <ProfilePage /> : <Navigate to="/auth" />
            }
          />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;

